export function yotpo() {
    const bottomLine = document.querySelector('.yotpo.bottomLine');

    // listen for click event
    if (bottomLine) {
        bottomLine.addEventListener('click', function () {

            // trigger event to open reviews tab
            window.dispatchEvent(new CustomEvent('opentab', { bubbles: true, detail: { tab: 'reviews' } }));
        });
    }
}
